import formAppSportRoomBlackouts from './formAppSportRoomBlackouts';
import formBlackoutsPostalCodes from './formBlackoutsPostalCodes';
import tableAppBlackouts from './tableAppBlackouts';

export default {
  title: 'Postal code form',
  attributeName:'postalCodes',
  createURL: 'blackoutsPostalCodes',
  sessionParams: [],
  getURL: 'blackoutsPostalCodes',
  updateURL: 'blackoutsPostalCodes',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  idUpdate:true,
  autoUpdate: false,
  formConfig: [
    formBlackoutsPostalCodes,
  ],
};
